import React, { useMemo } from 'react'
import styles from './styles.module.css'
import HeaderBackground from '../../../static/assets/header_backgrond.svg'
import ButtonHeader from '../ButtonHeader'

const Header = ({
  description = '',
  title = '',
  buttonLink = '',
  buttonText = '',
  buttonIcon = '',
  isSecundaryButton = false,
  isExternalLink = true,
}) => {
  const hasContentRightSide = useMemo(() => buttonLink && buttonText, [buttonLink, buttonText])

  const linkMap = {
    urlWebhook: process.env.URL_WEBHOOK,
    urlChangelogHotmart: process.env.URL_CHANGELOG_HOTMART,
  }

  return (
    <div className={styles.header}>
      <HeaderBackground className={styles.headerBackground} />
      <div className={styles.content}>
        <div className="_flex-1">
          {title && <h1>{title}</h1>}
          {description && <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }}></p>}
        </div>
        {hasContentRightSide && (
          <div className={`${styles.divButtonHeader} _flex-1`}>
            <ButtonHeader
              buttonLink={linkMap[buttonLink]}
              buttonText={buttonText}
              buttonIcon={buttonIcon}
              isSecundaryButton={isSecundaryButton}
              isExternalLink={isExternalLink}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Header
